import React from 'react';

function TodosError() {
  return <p>Sorry, there was a error</p>;
}

export { TodosError };